var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerbalmatelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "69px",
    height: "69px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#366796"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263A7A"
    },
    d: "M503.322,189.736l-81.513-81.605L258.872,234.892l-123.13,181.924l93.915,93.842 c8.661,0.884,17.448,1.341,26.341,1.341c141.384,0,256-114.616,256-256C512,233.082,508.971,210.873,503.322,189.736z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFEDB5"
    },
    cx: 203.128,
    cy: 350.522,
    r: 94.527
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#386895"
    },
    cx: 193.974,
    cy: 332.731,
    r: 8.594
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#386895"
    },
    cx: 247.398,
    cy: 332.731,
    r: 8.594
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#386895"
    },
    d: "M192.515,377.482c6.041,7.425,15.241,12.174,25.559,12.174s19.518-4.749,25.559-12.174H192.515z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7F4F"
    },
    d: "M409.686,103.041h-196.78c-9.378,0-16.98,7.602-16.98,16.98v97.89c0,9.378,7.602,16.98,16.98,16.98 h15.982v37.224c0,7.273,8.794,10.916,13.938,5.773l42.998-42.998h123.861c9.378,0,16.98-7.602,16.98-16.98v-97.89 C426.667,110.644,419.064,103.041,409.686,103.041z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5419"
    },
    d: "M409.686,103.04H307.143v131.851h102.543c9.378,0,16.98-7.602,16.98-16.98v-97.889 C426.667,110.642,419.064,103.04,409.686,103.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 228.883,
    y: 143.274,
    style: {
      fill: "#366695"
    },
    width: 164.823,
    height: 10.343
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.883,
    y: 176.235,
    style: {
      fill: "#366695"
    },
    width: 164.823,
    height: 10.343
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbalmatelogo);
export default __webpack_public_path__ + "static/media/verbalmatelogo.a5cb4fad71f1d83690bf2c39ead5e207.svg";
export { ForwardRef as ReactComponent };